import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, Divider } from '@material-ui/core';
import BenefitsTitle from '../BenefitsTitle';
import { useNoBenefitsStyles } from './styles';
import BenefitsFooter from '../BenefitsFooter';
import SilverStar from '../../../../../../assets/silver_star.svg';
import SilverStarWithPoints from '../../../../../../assets/silver_star_with_points.png';
import GoldenStarWithPoints from '../../../../../../assets/gold_star_with_points.png';
import BenefitsList from './BenefitsList';

const NoBenefits = ({ ...props }) => {
  const { mobile, benefits, points } = props;
  const classes = useNoBenefitsStyles();
  const [openSilver, setOpenSilver] = useState(false);
  const [openGold, setOpenGold] = useState(false);

  useEffect(() => {
    if (!mobile) {
      setOpenGold(true);
      setOpenSilver(true);
    }
  }, [mobile]);

  const handleOpenSilver = (event) => {
    setOpenSilver(event);
    setOpenGold(false);
  };

  const handleOpenGold = (event) => {
    setOpenGold(event);
    setOpenSilver(false);
  };

  return (
    <div className={classes.container}>
      <Grid container direction="column">
        <Grid item>
          <BenefitsTitle image={SilverStar} mobile={mobile} points={points} />
        </Grid>
        <Box className={mobile ? classes.boxMobile : classes.boxDesktop}>
          <BenefitsList
            image={SilverStarWithPoints}
            mobile={mobile}
            open={openSilver}
            setOpen={handleOpenSilver}
            benefits={benefits}
            type="Silver"
          />
          <BenefitsList
            image={GoldenStarWithPoints}
            mobile={mobile}
            open={openGold}
            setOpen={handleOpenGold}
            benefits={benefits}
            type="Gold"
          />
        </Box>
        <Divider className={classes.divider} />
        <BenefitsFooter mobile={mobile} />
      </Grid>
    </div>
  );
};

NoBenefits.propTypes = {
  mobile: PropTypes.bool,
  benefits: PropTypes.object,
  points: PropTypes.number,
};

export default NoBenefits;
